import { useEffect, useRef } from 'react';
/**
 * Get the previous value (was passed into hook on last render)
 */
export function usePrevious(value) {
    const ref = useRef(value);
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}
//# sourceMappingURL=usePrevious.js.map